import { ThemeProvider as NextThemesProvider } from "next-themes";

export function ThemeProvider({ children }) {
  // Light-only mode. forcedTheme overrides any saved preference and disables
  // the system → dark switch entirely. Public pages and admin pages all stay
  // in light mode.
  return (
    <NextThemesProvider attribute="class" defaultTheme="light" forcedTheme="light" enableSystem={false} storageKey="turf-theme">
      {children}
    </NextThemesProvider>
  );
}
